export function SkeletonRedactor() {
  return (
    <div className="flex flex-col gap-4 animate-pulse">
      <div className="flex flex-wrap gap-4">
        {[1, 2, 3].map((i) => (
          <div key={i} className="flex flex-col gap-1.5">
            <div className="h-4 w-16 rounded bg-muted" />
            <div className="h-9 w-40 rounded-md bg-muted" />
          </div>
        ))}
      </div>
      <div className="flex flex-col gap-1.5">
        <div className="h-4 w-24 rounded bg-muted" />
        <div className="h-40 w-full rounded-md bg-muted" />
      </div>
      <div className="flex gap-2">
        <div className="h-9 w-20 rounded-md bg-muted" />
      </div>
    </div>
  )
}
